import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterStateSnapshot, TitleStrategy } from "@angular/router";

@Injectable({ providedIn: "root" })
export class CustomTitleStrategy extends TitleStrategy {
  constructor(private title: Title) {
    super();
  }

  updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    // TODO: ggf. braucht es das nicht mehr?
    // const currentRoute = routerState.root;
    // console.debug('Aktuelle Route:', currentRoute, 'Generierter Titel:', title);

    if (title) {
      this.title.setTitle(`${title} | finsuro.mail - app.finsuro.de`);
    } else {
      console.warn(
        "Kein Titel gefunden für die aktuelle Route. Standardtitel wird verwendet."
      );
      this.title.setTitle("finsuro.mail - app.finsuro.mail");
    }
  }
}
